<script>
export default {
  name: 'ContactFormInput',
  props: {
    value: {
      type: Object,
      default: () => ({ name: null, email: null })
    },
    initial_validation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localName: {
      get() {
        return this.value.name
      },
      set(value) {
        this.$emit('input', { ...this.value, name: value })
      }
    },
    localEmail: {
      get() {
        return this.value.email
      },
      set(value) {
        this.$emit('input', { ...this.value, email: value })
      }
    },
    name_validation_rules() {
      return [
        {
          satisfied: this.localName && this.localName.length > 0,
          message: () => this.$t('components.contact_form.name.error_required')
        },
      ]
    },
    email_validation_rules() {
      return [
        {
          satisfied: this.localEmail && this.localEmail.length > 0,
          message: () => this.$t('components.contact_form.email.error_required')
        },
        {
          satisfied: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.localEmail),
          message: () => this.$t('components.contact_form.email.error_invalid_mail')
        }
      ]
    },
    fields() {
      return {
        name: {
          value: this.localName,
          rules: this.name_validation_rules,
        },
        email: {
          value: this.localEmail,
          rules: this.email_validation_rules,
        }
      }
    },
    validationState() {
      const result = {}
      for (const [key, field] of Object.entries(this.fields)) {
        if (!this.initial_validation) {
          if (field.value === null || field.value === undefined) {
            result[key] = { isValid: null, error: null }
            continue
          }
        }
        const failed = field.rules.find(r => !r.satisfied)
        result[key] = {
          isValid: !failed,
          error: failed ? failed.message() : null
        }
      }
      return result
    },
    isFormValid() {
      return Object.values(this.validationState).every(field => field.isValid)
    }
  },
  watch: {
    isFormValid: {
      immediate: true,
      handler(val) {
        this.$emit('validity-change', val)
      }
    }
  }
}
</script>

<template>
  <b-form-row class="mb-0 p-0">
    <b-col md="6">
      <b-form-group :label="$t('components.contact_form.name.label')" class="mb-0 p-0">
        <b-input v-model="localName" :state="validationState.name.isValid"></b-input>
        <b-form-invalid-feedback v-if="!validationState.name.isValid">{{ validationState.name.error }}</b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group :label="$t('components.contact_form.email.label')" class="mb-0 p-0">
        <b-input v-model="localEmail" :state="validationState.email.isValid"></b-input>
        <b-form-invalid-feedback v-if="!validationState.email.isValid">{{ validationState.email.error }}</b-form-invalid-feedback>
      </b-form-group>
    </b-col>
  </b-form-row>
</template>
